<template>
  <div class="box" @dragover.prevent @drop.prevent="onDrop">
    <div class="upload" @click="handOpen">
      <Resource
        :src="getFeUrl('/youyan-platform/png/upload-cloud.png')"
        class="w-[88px]"
        :transformResource="transformImage"
      />
      <a href="javascript:;">
        {{ $t('dian-ji-huo-tuo-zhuai-wen-jian-dao-ci-chu-shang-chuan') }}
      </a>
      <ul v-if="resourceType !== undefined" class="tip">
        <li v-for="x in uploadHintList" :key="x.limit">
          {{ x.label }}
          {{ $t('jin-zhi-chi') }}
          <b>{{ getAccept(x.accept) }}</b>
          {{ $t('ge-shi') }}{{ $t('key-0')
          }}{{
            $t('da-xiao-userinforightsrecordlimitmegabytexlimit-m', [
              userInfo!.rights_record.limit_megabyte[x.limit],
            ])
          }}
        </li>
      </ul>
      <div v-if="uploadHintList.find(item => item.accept === ACCEPT.PPT)" class="warn">
        {{
          $t(
            'ppt-cun-zai-pai-ban-he-zi-ti-diu-shi-feng-xian-jian-yi-ben-di-zhuan-cheng-pdf-hou-zai-dao-ru',
          )
        }}
      </div>
    </div>
    <RightsTip
      class="text-14 mt-[16px]"
      :resourceType="resourceType"
      :rights="rights"
      auxiliary
      :showVerify="showVerify"
      @cancel="onClose"
    />
  </div>
</template>

<script lang="ts" setup>
import { reqRightsDisplay } from '~/api';
import { USER_LEVEL_KEY } from '~/api/interface';
import { RESOURCE_TIPS, ACCEPT } from '~/hooks/useUpload';
import RightsTip from '~/features/pageList/components/tip.vue';

const props = defineProps<{
  resourceType?: number;
  onOpen: () => void;
  onClose: () => void;
}>();
const emit = defineEmits(['change']);

const userInfo = useUserInfo().value;

const rights = ref<Record<string, any>[]>([]);

const showVerify = computed(
  () =>
    userInfo &&
    !userInfo.is_identify &&
    ![USER_LEVEL_KEY.TASTE, USER_LEVEL_KEY.PERSONAL, USER_LEVEL_KEY.PERSONAL_LITE].includes(
      userInfo.rights_type,
    ),
);

const uploadHintList = computed(() => {
  if (props.resourceType === undefined) {
    return [];
  }
  return RESOURCE_TIPS()[props.resourceType] || [];
});

const getRights = async () => {
  const res = await reqRightsDisplay();
  if (res.code !== 0) {
    return;
  }

  if (!userInfo) {
    return;
  }

  rights.value =
    res?.data?.rights.filter(x => {
      // 企业标准、旗舰
      const company = [USER_LEVEL_KEY.ORG_STANDARD, USER_LEVEL_KEY.ORG_FLAGSHIP];
      const isOrg = company.includes(userInfo.rights_type);
      // 企业标准、旗舰不显示内容
      return company.includes(x.rights_type)
        ? false
        : x.rights_type > (isOrg ? 24 : userInfo.rights_type);
    }) || [];
};

const getAccept = (accept: string) => {
  const arr = accept.split(',');
  return arr.map(x => x.substring(1).toUpperCase()).join('、');
};

const handOpen = () => {
  props.onOpen();
};

const onDrop = (e: DragEvent) => {
  e.preventDefault();
  e.stopPropagation();
  const files = e?.dataTransfer?.files;
  if (files) {
    emit('change', files);
  }
};

getRights();
</script>

<style lang="scss" scoped>
.box {
  @apply w-full relative p-[24px];
}
.upload {
  @apply rounded-[8px] w-full h-[300px] bg-back-2 flex-center select-none flex-col cursor-pointer;
  border: 1px dashed var(--back-6);
  &:hover {
    @apply bg-purple-2 border-purple-5;
  }
  a {
    @apply text-14 font-semibold;
  }
  .tip {
    @apply text-12 text-font-50 mt-[20px] p-[12px_14px] bg-back-4 bg-opacity-[0.6] rounded-[8px];
    li {
      &::before {
        content: '';
        @apply inline-block w-[4px] h-[4px] rounded-[2px] mr-[8px] bg-font-1 bg-opacity-50;
        vertical-align: middle;
      }
      & + li {
        @apply mt-[4px];
      }
    }
  }

  .warn {
    @apply text-12 text-font-50 bg-back-4 bg-opacity-[0.6] mt-[10px];
  }
}
.upgradation {
  @apply flex-y-center text-14 font-semibold;
}
</style>
